module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAJhJREFUSA1jtPea8puBBGBrqfSjucbzPQlaGL7Utgn+OXqSgxQ9LK/efGEhRcPXb794gOpBmHjw9RvD31dviFcPVMlEkmo6Kh51GKmBPRpioyFGagiQqn40jY2GGKkhQKr60TQ2GmKkhgCp6kfT2GiIkRoCpKofTWOkhhiLubH8I1I0SUvyvwWqv0WKHiZpKTVWM2NhUvQAACwIGYlfssiKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/France.png
// module id = 469
// module chunks = 7